import { render, staticRenderFns } from "./BaseMultiselect.vue?vue&type=template&id=f5289ccc"
import script from "./BaseMultiselect.vue?vue&type=script&lang=js"
export * from "./BaseMultiselect.vue?vue&type=script&lang=js"
import style0 from "./BaseMultiselect.vue?vue&type=style&index=0&id=f5289ccc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports